export const harvestYieldsData = {
  data: {
    field: null,
  },
};
